import { CSSObject } from '@emotion/react';
import { HoneycombTheme, SpacingValue, createResponsiveStyles, useHoneycombTheme } from '../../../theming';
import { useCard } from '../Card.context';

function getPaddingStyles(theme: HoneycombTheme) {
    return (padding: SpacingValue): CSSObject => {
        return {
            padding: theme.fn.getSpacingValue(padding),
        };
    };
}

type StyleClasses = 'root';

export function useStyles(): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { padding } = useCard();

    const { theme } = useHoneycombTheme();

    const root: CSSObject = {
        display: 'block',
        ...createResponsiveStyles(
            [
                {
                    value: padding,
                    getStyles: getPaddingStyles(theme),
                },
            ],
            theme
        ),
    };

    return {
        styles: {
            root,
        },
    };
}
